export enum GiftWithPurchaseRequestStatusType {
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED'
}

export enum GiftWithPurchaseConditionType {
  PURCHASE_AMOUNT = 'PURCHASE_AMOUNT',
  PURCHASE_QUANTITY = 'PURCHASE_QUANTITY'
}

export enum GiftWithPurchaseModeEnum {
  REQUEST_VIEW = 'VIEW'
}
